// i18n配置文件
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

// 注册vue-i18n插件
Vue.use(VueI18n)

// 获取浏览器语言设置
const getDefaultLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.indexOf('zh') !== -1) {
    return 'zh-CN'
  } else {
    return 'en-US'
  }
}

// 创建i18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || getDefaultLanguage(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

// 导出切换语言的方法
export const setLanguage = (lang) => {
  i18n.locale = lang
  localStorage.setItem('language', lang)
}

export default i18n